module.exports = __webpack_public_path__ + "static/img/c_znzz73.05d4cee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c_znzz73.png
// module id = n7Sv
// module chunks = 73